import { contextConnect } from '../../context';
import { View } from '../../view';
import { useNavigatorButton } from './hook';
import { jsx as _jsx } from "react/jsx-runtime";
function UnconnectedNavigatorButton(props, forwardedRef) {
  const navigatorButtonProps = useNavigatorButton(props);
  return /*#__PURE__*/_jsx(View, {
    ref: forwardedRef,
    ...navigatorButtonProps
  });
}
export const NavigatorButton = contextConnect(UnconnectedNavigatorButton, 'Navigator.Button');